export default __webpack_public_path__ + "static/media/ashwini.a53b95c5.jpeg";